import { Button, Callout, FormGroup, MenuItem, Tab, Tabs } from "@blueprintjs/core";
import { Select, ItemRenderer } from "@blueprintjs/select";
import React, { useCallback } from "react";
import { NewScheduleState, PeriodicSchedule, PeriodicSubType } from "types";
import { generateNumbers } from "utils/utils";
type Props = {
    periodic: PeriodicSchedule;
    update: (name: keyof NewScheduleState, value: PeriodicSchedule) => void;
};

export default function Periodic({ periodic, update }: Props) {
    const clear = useCallback(() => {
        update("periodic", { name: undefined, value: undefined });
    }, [update]);
    return (
        <Callout>
            <Tabs id="Periodic" key={"horizontal"} onChange={clear} defaultSelectedTabId={periodic.name}>
                {tabs.map((t, index) => (
                    <Tab
                        key={index}
                        id={t.name.toLowerCase()}
                        title={t.name}
                        panel={
                            <>
                                <FormGroup
                                    inline
                                    key={`select_${t.name} `}
                                    label={"Every"}
                                    labelFor="text-input"
                                    helperText={periodic.value ? undefined : "Please select the frequency."}
                                >
                                    <NumberSelect
                                        filterable={false}
                                        itemRenderer={renderNumbers}
                                        items={t.intervals}
                                        onItemSelect={(n) => {
                                            update("periodic", {
                                                name: t.name.toLowerCase() as PeriodicSubType,
                                                value: n
                                            });
                                        }}
                                        noResults={<MenuItem disabled={true} text="No results." />}
                                        popoverProps={{ minimal: true, popoverClassName: "custom-select" }}
                                    >
                                        <Button text={periodic.value ? periodic.value : "..."} rightIcon="caret-down" />
                                    </NumberSelect>
                                    <div
                                        style={{
                                            display: "inline-flex",
                                            lineHeight: "30px",
                                            margin: "0 0  0 10px"
                                        }}
                                    >
                                        {`${t.name}(s)`}
                                    </div>
                                    {/* //todo: fiugreout how to clear active item */}
                                    {periodic.value && <Button icon="cross" minimal intent="danger" onClick={clear} />}
                                </FormGroup>
                            </>
                        }
                    />
                ))}
            </Tabs>
        </Callout>
    );
}
const minuteIntervals = [15, 20, 30];
const hourIntervals = [1, 2, 3, 4, 6, 8, 12];
const weekIntervals = [1, 2, 3];

const tabs: { name: string; intervals: number[] }[] = [
    { name: "Minute", intervals: minuteIntervals },
    { name: "Hour", intervals: hourIntervals },
    { name: "Day", intervals: generateNumbers(31) },
    { name: "Week", intervals: weekIntervals },
    { name: "Month", intervals: generateNumbers(12) }
];

const NumberSelect = Select.ofType<number>();

const renderNumbers: ItemRenderer<number> = (n, { handleClick, modifiers }) => {
    if (!modifiers.matchesPredicate) {
        return null;
    }
    return <MenuItem active={modifiers.active} key={`choice_${n}`} onClick={handleClick} text={n} />;
};
